<template>
  <!-- 新闻 -->
  <div class="">
    <HeaderTop />
    <MenuPage />
    <BannerDetail
      :backgroundImage="require('../assets/img/banner11.jpg')"
      :title="$t('newbannertitle')"
      :description="$t('newbannerdescription')"
    />
    <div class="new-main">
      <NewItem />
    </div>

    <div class="footer-main">
      {{ $t("footertitile") }}
    </div>
  </div>
</template>

<script>
import MenuPage from "../components/MenuPage.vue";
import HeaderTop from "../components/HeaderTop.vue";
import BannerDetail from "@/components/BannerDetail.vue";
import NewItem from "@/components/NewItem.vue";
export default {
  components: { HeaderTop, MenuPage, BannerDetail, NewItem },
  name: "NewsPage",
};
</script>
<style scoped>
.new-main {
  float: left;
  width: 100%;
  background: #f6f6f6;
  padding-bottom: 50px;
}
</style>
